export default __webpack_public_path__ + "static/media/msg-ann.db578549.svg";